import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import AppButton from "../../components/app-button/AppButton";
import AppDialog from "../../components/app-dialog/AppDialog";
import PrintReceipt from "../../components/app-receipts/PrintReceipt";
import Iconify from "../../components/iconify/Iconify";
import PaymentInfo from "../../components/payment-info/PaymentInfo";
import TableCard from "../../components/table-card/TableCard";
import { ORDER_TABLE_STATUS } from "../../constants/enums";
import {
  clearActiveOrderUidInSession,
  clearCart,
  selectTable,
  setActiveOrderUidInSession,
} from "../../reduxStore/slices/cartSlice";
import {
  calculateBusyTableCount,
  getAllTables,
} from "../../reduxStore/slices/tableSlice";
import { useNotify } from "../../utils/snackbarUtils";
import "./Tables.css";
import TableViewEmptyState from "./TableViewEmptyState";

function Tables(props) {
  const dispatch = useDispatch();
  const { showSuccess, handleApiError, showError } = useNotify();
  const { user } = useSelector((state) => state.auth);
  const { details } = useSelector((state) => state.store);
  const { tableDines, loading: isLoading } = useSelector(
    (state) => state.table,
  );

  const storeId = user?.storeId;
  const navigate = useNavigate();
  const [isSettleDialogOpen, setIsSettleDialogOpen] = useState(false);
  const [isMergeDialogOpen, setIsMergeDialogOpen] = useState(false);
  const [isSplitDialogOpen, setIsSplitDialogOpen] = useState(false);
  const [selectedTables, setSelectedTables] = useState([]);
  const [splitChips, setSplitChips] = useState(["T3-1", "T3-2"]);
  const [selectedOrderForPay, setSelectedOrderForPay] = useState({});
  const [printOrderData, setPrintOrderData] = useState(null);

  // 1. Create the reference
  const printRef = useRef();

  const baseTable = "T3 (Garden)";

  const handleDialogCancel = () => {
    setIsSettleDialogOpen(false);
    setIsMergeDialogOpen(false);
    setIsSplitDialogOpen(false);
  };

  const handleMoveKOTItem = () => {};

  const handleSettleDialog = (table) => {
    console.log("Table for settle:", table);
    const orderDetails = getTableWithDineData(table);
    setSelectedOrderForPay(orderDetails);
    setIsSettleDialogOpen(true);
  };

  const handleTableClick = (table) => {
    console.log("Clicked Table:", table);
    if (table?.order?.order_uid) {
      setActiveOrderUidInSession(table?.order?.order_uid);
    } else {
      clearActiveOrderUidInSession();
    }
    const orderDetails = getTableWithDineData(table);
    console.log("Order Details:", orderDetails);
    dispatch(clearCart());
    dispatch(selectTable(orderDetails));
    navigate(`/app/menu`);
  };

  // 2. Configure the print hook
  const handlePrint = useReactToPrint({
    contentRef: printRef, // Points to the forwardRef in ReceiptPrint
    onAfterPrint: () => console.log("Print process finished"),
    onPrintError: (error) => console.error("Print Error:", error),
  });

  const handlePrintClick = (table) => {
    // const orderData = getTableWithDineData(table);
    // const allItems = mergeItemsByVariant(orderData?.kots || []);

    // const storeInfo = {
    //   restaurantName: details?.store_name,
    //   vpa: "mycafe@upi",
    //   contact: `Call: ${details?.contact_no}`,
    //   address: details?.address,
    //   logoUrl: details?.logo,
    //   footerNote: "Thank you for dining with us!",
    //   gstNumber: "22AAAAA0000A1Z5",
    // };

    // // We intentionally create a new object reference to trigger the useEffect
    // // even if the data is the same (e.g. re-printing)
    // setPrintOrderData({
    //   ...orderData,
    //   storeInfo,
    //   items: allItems,
    //   waiter: orderData?.waiter_name || "N/A",
    //   _timestamp: Date.now(),
    // });

    // // This is called after your API returns 200 OK for the payment
    // setPrintData({
    //   ...orderData,
    //   storeInfo,
    //   items: allItems,
    //   waiter: orderData?.waiter_name || "N/A",
    //   _timestamp: Date.now(),
    // });

    setTimeout(() => {
      handlePrint();
    }, 200);
  };

  const getTableWithDineData = (table) => {
    const dine = {
      dine_area_uid: table?.dineId || null,
      dine_area_name: table?.dineName || null,
      table: {
        dine_area_table_uid: table?.dine_area_table_uid || null,
        table_name: table?.table_name || null,
        chairs: table?.chairs || null,
        order_dine_table_id: table?.order_dine_table_id,
        order_dine_table_status_id: table?.order_dine_table_status_id,
        order_dine_table_uid: table?.order_dine_table_uid,
      },
    };
    const orderDetails = {
      ...table.order,
      dine: dine,
    };
    return orderDetails;
  };

  const handleMergeTable = () => {
    setIsMergeDialogOpen(true);
  };

  const handleSplitTable = () => {
    setIsSplitDialogOpen(true);
  };

  const handleSelectTable = (id) => {
    setSelectedTables((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id],
    );
  };

  const handleAddChip = () => {
    const nextNumber = splitChips.length + 1;
    setSplitChips([...splitChips, `T3-${nextNumber}`]);
  };

  const handleRemoveChip = (index) => {
    const newChips = splitChips.filter((_, i) => i !== index);
    const reIndexed = newChips.map((_, i) => `T3-${i + 1}`);
    setSplitChips(reIndexed);
  };

  const tables1 = [
    { id: "T4", label: "T4 (Patio)", status: "Free" },
    { id: "T5", label: "T5 (Garden)", status: "Free" },
    { id: "T6", label: "T6 (Main)", status: "Occupied", disabled: true },
  ];

  const fetchAllTables = async () => {
    try {
      const obj = {
        offset: 0,
        limit: 10,
        storeId: storeId,
      };
      await dispatch(getAllTables(obj)).unwrap();
      dispatch(calculateBusyTableCount());
    } catch (err) {
      handleApiError(err);
    }
  };

  const addTable = async () => {
    navigate(`/app/config/dine-tables`);
  };

  useEffect(() => {
    if (storeId) {
      fetchAllTables();
    }
  }, [storeId]);

  const dialogMergeTableFooter = (
    <>
      <Box
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <Button size="medium" onClick={handleDialogCancel}>
          Cancel
        </Button>
        <AppButton
          disabled={isLoading}
          isLoading={isLoading}
          fullWidth
          size="medium"
          variant="contained"
        >
          Merge
        </AppButton>
      </Box>
    </>
  );

  const dialogSplitTableFooter = (
    <>
      <Box
        style={{
          display: "flex",
          gap: 15,
        }}
      >
        <Button size="medium" onClick={handleDialogCancel}>
          Cancel
        </Button>
        <AppButton
          disabled={isLoading}
          isLoading={isLoading}
          fullWidth
          size="medium"
          variant="contained"
        >
          Split
        </AppButton>
      </Box>
    </>
  );

  return (
    <>
      <div style={{ display: "none" }}>
        <div ref={printRef}>
          <PrintReceipt paperSize="80mm" />
        </div>
      </div>
      <Box className="order-page-content">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h5" gutterBottom>
            Table View
          </Typography>
          <Box className="table-btns-wrap">
            {/* <Tooltip title="MOVE KOT/ Items" onClick={handleMoveKOTItem}>
              <IconButton>
                <Iconify icon="material-symbols:compare-arrows-rounded" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Merge Table">
              <IconButton onClick={handleMergeTable}>
                <Iconify icon="mdi:table-merge-cells" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Split Table" onClick={handleSplitTable}>
              <IconButton>
                <Iconify icon="mdi:table-split-cell" />
              </IconButton>
            </Tooltip> */}
            <AppButton
              style={{
                background: "#e0a800",
              }}
              onClick={fetchAllTables}
              isLoading={isLoading}
              variant="contained"
              startIcon={<Iconify icon="solar:refresh-bold-duotone" />}
            >
              Refresh
            </AppButton>
            {tableDines.length !== 0 && (
              <AppButton
                onClick={addTable}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                Add Table
              </AppButton>
            )}
          </Box>
        </Stack>
        <Box className="table-status-wrap">
          {Object.values(ORDER_TABLE_STATUS).map((status) => (
            <Box className="table-status-content" key={status.id}>
              <Box
                className="table-status-ico"
                style={{
                  background: status.color,
                }}
              ></Box>
              <Box className="table-status-name">{status.label}</Box>
            </Box>
          ))}

          {/* <Box className="table-status-content">
            <Box
              className="table-status-ico"
              style={{
                background: "#E2E8F0",
              }}
            ></Box>
            <Box className="table-status-name">Free Table</Box>
          </Box>
          <Box className="table-status-content">
            <Box
              className="table-status-ico"
              style={{
                background: "#0d6efd",
              }}
            ></Box>
            <Box className="table-status-name">Occupied Table</Box>
          </Box>
          <Box className="table-status-content">
            <Box
              className="table-status-ico"
              style={{
                background: "#6f42c1",
              }}
            ></Box>
            <Box className="table-status-name">Running KOT Table</Box>
          </Box>
          <Box className="table-status-content">
            <Box
              className="table-status-ico"
              style={{
                background: "#fd7e14",
              }}
            ></Box>
            <Box className="table-status-name">Printed Table</Box>
          </Box>
          <Box className="table-status-content">
            <Box
              className="table-status-ico"
              style={{
                background: "#198754",
              }}
            ></Box>
            <Box className="table-status-name">Paid Table</Box>
          </Box> */}
        </Box>
        {tableDines.length === 0 && !isLoading && (
          <TableViewEmptyState onTableClick={addTable} />
        )}

        {tableDines.length !== 0 && (
          <Box>
            {tableDines &&
              tableDines?.map((tableDine, key) => {
                return (
                  <Box key={tableDine.dine_area_uid}>
                    <Box
                      className="table-dine-caption"
                      sx={{
                        fontSize: 15,
                        fontWeight: 600,
                      }}
                    >
                      {tableDine.dine_area_name}
                    </Box>
                    <Box className="table-tbl-content">
                      {tableDine.tables &&
                        tableDine.tables?.map((table, key) => {
                          return (
                            <TableCard
                              table={table}
                              key={table.dine_area_table_uid}
                              dineName={tableDine.dine_area_name}
                              dineId={tableDine.dine_area_uid}
                              onPayClick={handleSettleDialog}
                              onTableClick={handleTableClick}
                              onPrintClick={handlePrintClick}
                            />
                          );
                        })}
                    </Box>
                  </Box>
                );
              })}
          </Box>
        )}
      </Box>
      {isSettleDialogOpen && (
        <PaymentInfo
          isSettleDialogOpen={isSettleDialogOpen}
          onDialogCancel={handleDialogCancel}
          orderDetails={selectedOrderForPay}
        />
      )}
      {isMergeDialogOpen && (
        <AppDialog
          maxWidth="xs"
          isOpen={isMergeDialogOpen}
          id={"merge_table_dialog"}
          title={<>{"Merge Tables"}</>}
          footer={dialogMergeTableFooter}
        >
          <Box
            style={{
              margin: "20px 5px",
            }}
          >
            <Box>
              {/* <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel>New Table</InputLabel>
                <Select
                  // value={newTable}
                  label="New Table"
                  // onChange={(e) => setNewTable(e.target.value)}
                >
                  <MenuItem value="T3">T3 (Garden)</MenuItem>
                  <MenuItem value="T4">T4 (Patio)</MenuItem>
                  <MenuItem value="T5">T5 (Balcony)</MenuItem>
                </Select>
              </FormControl> */}

              {/* Options */}
              <Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Select tables:
                  </Typography>
                  <FormGroup>
                    {tables1.map((table) => (
                      <FormControlLabel
                        key={table.id}
                        control={
                          <Checkbox
                            checked={selectedTables.includes(table.id)}
                            onChange={() => handleSelectTable(table.id)}
                            disabled={table.disabled}
                          />
                        }
                        label={`${table.label} - ${table.status}`}
                      />
                    ))}
                  </FormGroup>
                </Box>

                <Box sx={{ mt: 2, p: 2, bgcolor: "#f0f4f8", borderRadius: 2 }}>
                  <Typography variant="body2">
                    Result: <b>T3 (Garden)</b> +{" "}
                    {selectedTables
                      .map((id) => tables1.find((t) => t.id === id)?.label)
                      .join(", ")}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Orders will be combined into one bill.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </AppDialog>
      )}
      {isSplitDialogOpen && (
        <AppDialog
          maxWidth="xs"
          isOpen={isSplitDialogOpen}
          id={"split_table_dialog"}
          title={<>{"Split Table"}</>}
          footer={dialogSplitTableFooter}
        >
          <Box
            style={{
              margin: "20px 5px",
            }}
          >
            <Box>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel>New Table</InputLabel>
                <Select
                  // value={newTable}
                  label="New Table"
                  // onChange={(e) => setNewTable(e.target.value)}
                >
                  <MenuItem value="T3">T3 (Garden)</MenuItem>
                  <MenuItem value="T4">T4 (Patio)</MenuItem>
                  <MenuItem value="T5">T5 (Balcony)</MenuItem>
                </Select>
              </FormControl>

              <Box sx={{ mt: 3, p: 2, bgcolor: "#fff3e0", borderRadius: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Split {baseTable} into:
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {splitChips.map((chip, index) => (
                    <Chip
                      key={chip}
                      label={chip}
                      onDelete={() => handleRemoveChip(index)}
                      deleteIcon={<Iconify icon={"material-symbols:close"} />}
                      sx={{ mb: 1 }}
                    />
                  ))}
                  <IconButton
                    size="small"
                    onClick={handleAddChip}
                    color="primary"
                  >
                    <Iconify icon={"material-symbols:add"} />
                  </IconButton>
                </Stack>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 1 }}
                >
                  Orders will be billed separately per sub-table.
                </Typography>
              </Box>
            </Box>
          </Box>
        </AppDialog>
      )}
    </>
  );
}

export default Tables;
